import { Card } from "../../../components/ui";
import { useState, useEffect } from "react";
import { fetchedMatrix } from "../../../apis/apis.logistics/apisProduct";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

export function MatrixPage() {
    const [products, setProducts] = useState([]);

    const getMatrix = async () => {
        console.log('getMatrix')
        try {
          const response = await fetchedMatrix();
          setProducts(response);
          return response;
        } catch (error) {
          throw error;
        }
    };

    useEffect(() => {
        getMatrix();
    }, []);

    // Clases reutilizables para celdas coloreadas con soporte dark mode
    const thBase = "px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600";
    const tdBase = "px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700";

    // Paleta de colores semánticos adaptados a dark/light
    const thSky   = `${thBase} bg-sky-100   dark:bg-sky-900/40   text-sky-800   dark:text-sky-200`;
    const thBlue  = `${thBase} bg-blue-100  dark:bg-blue-900/40  text-blue-800  dark:text-blue-200`;
    const thCyan  = `${thBase} bg-cyan-100  dark:bg-cyan-900/40  text-cyan-800  dark:text-cyan-200`;
    const thGreen = `${thBase} bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-200`;
    const thAmber = `${thBase} bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200`;
    const thNeutral = `${thBase} bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200`;

    const tdSky   = `${tdBase} bg-sky-50   dark:bg-sky-900/20   text-gray-800 dark:text-sky-100`;
    const tdBlue  = `${tdBase} bg-blue-50  dark:bg-blue-900/20  text-blue-900 dark:text-blue-100 font-semibold text-center`;
    const tdCyan  = `${tdBase} bg-cyan-50  dark:bg-cyan-900/20  text-cyan-900 dark:text-cyan-100`;
    const tdGreen = `${tdBase} bg-emerald-50 dark:bg-emerald-900/20 text-emerald-900 dark:text-emerald-100`;
    const tdAmber = `${tdBase} bg-amber-50 dark:bg-amber-900/20 text-amber-900 dark:text-amber-100`;
    const tdNeutral = `${tdBase} text-gray-700 dark:text-gray-300`;

    return (
        <>
            {/* Header de página */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                                Módulo Logístico
                            </h1>
                        </div>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li>
                                    <a href="#" className="text-blue-600 dark:text-blue-400 hover:underline transition-colors">
                                        Logística
                                    </a>
                                </li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">/</li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">
                                    Matriz de productos
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            {/* Tabla principal */}
            <section>
                <div className="max-w-full px-4">
                    <Card className="shadow-sm border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">

                        {/* Card header */}
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
                            <div>
                                <h2 className="text-base font-semibold text-gray-900 dark:text-white">
                                    Matriz de productos
                                </h2>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Almacén Central</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-100 dark:bg-gray-700 px-3 py-1 text-xs font-medium text-gray-600 dark:text-gray-300">
                                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                                    {products.length} productos
                                </span>
                                <ReactHTMLTableToExcel
                                    id="test-table-xls-button"
                                    className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white text-xs font-medium px-3 py-1.5 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                                    table="table-to-xls"
                                    filename="matriz_de_productos"
                                    sheet="report"
                                    buttonText="↓ Exportar XLS"
                                />
                            </div>
                        </div>

                        {/* Leyenda de colores */}
                        <div className="flex flex-wrap gap-3 px-5 py-3 bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700 text-xs text-gray-500 dark:text-gray-400">
                            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-sky-200 dark:bg-sky-700"></span>Info producto</span>
                            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-blue-200 dark:bg-blue-700"></span>Stock / Pepsico</span>
                            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-cyan-200 dark:bg-cyan-700"></span>P.V.</span>
                            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-emerald-200 dark:bg-emerald-700"></span>Costo Docena</span>
                            <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-amber-200 dark:bg-amber-700"></span>Costo Unit</span>
                        </div>

                        {/* Tabla */}
                        <div className="overflow-x-auto bg-white dark:bg-gray-900">
                            <table
                                className="min-w-full text-sm border-separate border-spacing-0"
                                id="table-to-xls"
                            >
                                <thead className="sticky top-0 z-10">
                                    {/* Fila de grupos */}
                                    <tr>
                                        <th
                                            colSpan={10}
                                            className="bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-600"
                                        />
                                        <th
                                            colSpan={3}
                                            className={`${thBase} bg-cyan-600 dark:bg-cyan-800 text-white border-l-2 border-cyan-400 dark:border-cyan-600`}
                                        >
                                            Costo Tienda
                                        </th>
                                        <th
                                            colSpan={3}
                                            className={`${thBase} bg-blue-600 dark:bg-blue-800 text-white border-l-2 border-blue-400 dark:border-blue-600`}
                                        >
                                            Costo Mayorista
                                        </th>
                                        <th
                                            colSpan={3}
                                            className={`${thBase} bg-violet-600 dark:bg-violet-800 text-white border-l-2 border-violet-400 dark:border-violet-600`}
                                        >
                                            Costo para Sunat
                                        </th>
                                    </tr>

                                    {/* Fila de columnas */}
                                    <tr>
                                        <th className={thSky}>Código</th>
                                        <th className={thSky}>Clasificación</th>
                                        <th className={thSky}>SKU</th>
                                        <th className={thSky}>Descripción PEPSICO</th>
                                        <th className={thSky}>Descripción LAYS</th>
                                        <th className={thBlue}>Cantidad</th>
                                        <th className={thNeutral}>Gramaje</th>
                                        <th className={thNeutral}>Marca</th>
                                        <th className={thBlue}>Costo Caja Pepsico</th>
                                        <th className={thBlue}>Costo Unit Pepsico</th>

                                        <th className={`${thCyan} border-l-2 border-cyan-300 dark:border-cyan-600`}>P.V.</th>
                                        <th className={thGreen}>Costo Docena</th>
                                        <th className={thAmber}>Costo Unit</th>

                                        <th className={`${thCyan} border-l-2 border-blue-300 dark:border-blue-600`}>P.V.</th>
                                        <th className={thGreen}>Costo Docena</th>
                                        <th className={thAmber}>Costo Unit</th>

                                        <th className={`${thCyan} border-l-2 border-violet-300 dark:border-violet-600`}>P.V.</th>
                                        <th className={thGreen}>Costo Docena</th>
                                        <th className={thAmber}>Costo Unit</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {products.map((item, index) => (
                                        <tr
                                            key={index}
                                            className="group transition-colors hover:brightness-95 dark:hover:brightness-110"
                                        >
                                            <td className={tdSky}>{item.productCode}</td>
                                            <td className={tdSky}>{item.productClassificationDisplay}</td>
                                            <td className={tdSky}>{item.productSku}</td>
                                            <td className={tdSky}>{item.productPurchaseName}</td>
                                            <td className={tdSky}>{item.productSaleName}</td>
                                            <td className={tdBlue}>{item.remainingQuantity}</td>
                                            <td className={tdNeutral}>{item.productGrammage}</td>
                                            <td className={tdNeutral}>{item.productBrandName}</td>
                                            <td className={tdNeutral}>{item.maxProductTariffPricePurchase}</td>
                                            <td className={tdNeutral}>{item.maxProductTariffPriceSale}</td>

                                            <td className={`${tdCyan} border-l-2 border-cyan-200 dark:border-cyan-700`}>{item.minProductTariffPriceSaleWholesale}</td>
                                            <td className={tdGreen}>{Number(item.minProductTariffPricePurchaseWholesale * 12).toFixed(6)}</td>
                                            <td className={tdAmber}>{item.minProductTariffPricePurchaseWholesale}</td>

                                            <td className={`${tdCyan} border-l-2 border-blue-200 dark:border-blue-700`}>{item.minProductTariffPriceSalePrimax}</td>
                                            <td className={tdGreen}>{Number(item.minProductTariffPricePurchasePrimax * 12).toFixed(6)}</td>
                                            <td className={tdAmber}>{item.minProductTariffPricePurchasePrimax}</td>

                                            <td className={`${tdCyan} border-l-2 border-violet-200 dark:border-violet-700`}>{item.minProductTariffPriceSaleSunat}</td>
                                            <td className={tdGreen}>{Number(item.minProductTariffPricePurchaseSunat * 12).toFixed(6)}</td>
                                            <td className={tdAmber}>{item.minProductTariffPricePurchaseSunat}</td>
                                        </tr>
                                    ))}

                                    {/* Estado vacío */}
                                    {products.length === 0 && (
                                        <tr>
                                            <td
                                                colSpan={19}
                                                className="py-12 text-center text-sm text-gray-400 dark:text-gray-500"
                                            >
                                                No hay productos disponibles
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </Card>
                </div>
            </section>
        </>
    )
}
